// ═══════════════════════════════════════════════════════════════
// MÓDULO: Solicitudes
// ═══════════════════════════════════════════════════════════════

import React, { useState, useCallback, useEffect } from 'react';
import ListaSolicitudes    from './components/ListaSolicitudes';
import DetalleSolicitud    from './components/DetalleSolicitud';
import CrearSolicitudModal from './components/CrearSolicitudModal';

export default function SolicitudesModule({ currentCompany, currentUser, deepLinkId, onDeepLinkConsumed }) {
  const [view, setView]             = useState('lista');
  const [selectedId, setSelectedId] = useState(null);
  const [showCrear, setShowCrear]   = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const refresh = useCallback(() => setRefreshKey(k => k + 1), []);

  // Deep link desde módulo Aprobaciones
  useEffect(() => {
    if (deepLinkId) {
      setSelectedId(deepLinkId);
      setView('detalle');
      if (onDeepLinkConsumed) onDeepLinkConsumed();
    }
  }, [deepLinkId]); // eslint-disable-line

  if (view === 'detalle' && selectedId) {
    return (
      <DetalleSolicitud
        solicitudId={selectedId}
        currentCompany={currentCompany}
        currentUser={currentUser}
        onBack={() => { setSelectedId(null); setView('lista'); }}
        onRefresh={() => { refresh(); setSelectedId(null); setView('lista'); }}
      />
    );
  }

  return (
    <>
      <ListaSolicitudes
        currentCompany={currentCompany}
        currentUser={currentUser}
        refreshKey={refreshKey}
        onSelect={(s) => { setSelectedId(s.id); setView('detalle'); }}
        onCrear={() => setShowCrear(true)}
      />

      {showCrear && (
        <CrearSolicitudModal
          currentCompany={currentCompany}
          currentUser={currentUser}
          onClose={() => setShowCrear(false)}
          onSuccess={() => { setShowCrear(false); refresh(); }}
        />
      )}
    </>
  );
}
